import { render, staticRenderFns } from "./bank-link-success.vue?vue&type=template&id=1342066c&scoped=true&"
import script from "./bank-link-success.vue?vue&type=script&lang=js&"
export * from "./bank-link-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1342066c",
  null
  
)

export default component.exports